import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/system-set',
      name: 'admin-system-set',
      component: () => import(/* webpackChunkName: "page-admin-system-management-system-set" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "系统设置"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "系统管理"
                                        },
                                        {
                                                  name: "系统设置"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
